import React, { useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PagedTable from '../../Reusable/Lists/PagedTable';
import { Divider, Button, Grid } from 'semantic-ui-react';
import useListOneToOnes from '../../Hooks/Users/OneToOne/useListOneToOnes';
import { useParams } from 'react-router-dom';
import SubNavigation from '../../Pages/User/SubNavigation';
import { StateContext } from '../../Context/StateContext';

const OneToOneList = (props) => {

    const { id } = useParams();
    const { t } = useTranslation();
    const { oneToOnes, listOneToOnes } = useListOneToOnes();
    const { userDetailBackRoute } = useContext(StateContext);

    // Fetch one to ones
    useEffect(() => {
        (async () => {
            await listOneToOnes(id);
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    // add detail link to one to one array
    useEffect(() => {
        oneToOnes.map(item => {
            item.viewUrl = 'detail/';
            item.link=t('general.view');
            return item;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[oneToOnes]);
    
    return (
        <div>
            <SubNavigation id={id} activePage='onetoones' />

            <Grid stackable columns={2} className="add-margin">
                <Grid.Column><h1>{t('heading.oneToOnes')}</h1></Grid.Column>
                <Grid.Column>
                    <Button floated='right' onClick={() => props.history.push('/user/' + id + '/onetoone/new')}>{t('oneToOne.add')}</Button>
                </Grid.Column>
            </Grid>
                
            <PagedTable unstackable striped celled compact='very'
                header={[
                    t('oneToOne.date'),
                    t('oneToOne.description'),
                    ''
                ]}
                content={oneToOnes}
                contentKeys={[
                    {key: 'Date', type: 'date'},
                    {key: 'Description', type: 'firstChars', limit: 100},
                    {key: 'link', type: 'url', urlKey:'viewUrl', cellAlign: 'left', targetKey: 'Id'},
                ]}
                pageSize='20'
            />

            <Divider />
            <Button onClick={() => props.history.push(userDetailBackRoute || '/user/list')}>{t('general.backToUserList')}</Button>
            
                
        </div>
    );

}

export default OneToOneList;
